import { useState } from 'react'

import Divider from '~/bootcamp/Activities/components/Divider'

const FractionDraggableCard = ({
  denominator,
  numerator,
  id,
}: {
  denominator: number
  numerator: number
  id: string
}): React.ReactElement => {
  const [isDragging, setIsDragging] = useState(false)

  return (
    <div
      className={`w-full h-full text-center text-sm flex justify-center items-center rounded-small ${
        isDragging ? 'bg-purple text-white' : 'bg-transparent'
      }`}
      draggable
      id={id}
      onDragEnd={() => {
        setIsDragging(false)
      }}
      onDragStart={(e) => {
        e.dataTransfer.setData('id', e.currentTarget.id)
        setIsDragging(true)
      }}
    >
      <span>
        <span>{numerator}</span>
        <Divider className={`w-5 ${isDragging ? 'bg-white' : ''}`} />
        {denominator}
      </span>
    </div>
  )
}

export default FractionDraggableCard
